#import "../fragments/sales-document-fragment.graphql"

mutation UpdateQuoteSubtotal($input: QuoteSubtotalItemsUpdateInput!) {
    quoteSubtotalItemsUpdate(input: $input) {
        salesDocument {
            ...SalesDocumentFragment
        }
    }
}
